export const totalPremium = (regularPremium, regularTopUp, lumpSum) => regularPremium.plus(regularTopUp).plus(lumpSum)
